<script lang="ts">
	import {word} from './stores.js';
	import check from './check_random/check'
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	//import Slider from '@smui/slider';
	//import FormField from '@smui/form-field';

	// initializing of variables
	let simpleDialog;

	let wordInput: string, reason: string;
	$: wordInput = $word;

	function uqnClick(){
		wordInput = wordInput.trim();
		let array = check(wordInput);
		if (array[0]){
			word.set(wordInput.toUpperCase());
		} else{
			reason = array[1];
			simpleDialog.open();
		}
	}
	
</script>

<h2>Options</h2>
<hr>
<h3>Question construction tool</h3>
<p>
	Generate a question by keying in a word:
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={wordInput} label="word" type="text"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<!-- <Icon class="material-icons">favorite</Icon> -->
	<Label>Generate question</Label>
</Button>
<hr>
<p>A valid word for this question will contain at least 3 distinct letters and a total of at most 13 letters.<br>
	Only letters are accepted: no symbols, numbers or spaces are allowed.</p>


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid word</Title>
	<Content>
		You have submitted an invalid word as they are {reason}. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>